import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React from "react";
import Styles from "./css/footerlinkssingle.module.scss";
import { isChrome, isFirefox, isIeEdge, getBrowser } from "@tightrope/lpscripts/browserdetect";
var FooterlinksSingle = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(FooterlinksSingle, _React$Component);
  function FooterlinksSingle(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.state = {
      display: "block",
      unsubscribe: false,
      language: "en"
    };
    if (props.data) {
      _this.state.data = props.data;
    }
    if (props.unsubscribe) {
      _this.setState({
        unsubscribe: props.unsubscribe
      });
    }
    return _this;
  }
  var _proto = FooterlinksSingle.prototype;
  _proto.showBrowsers = function showBrowsers(browsers) {
    var display = false;
    if (getBrowser() === 'ie' && browsers.includes('ie')) {
      display = true;
    }
    if (getBrowser() === 'firefox' && browsers.includes('firefox')) {
      display = true;
    }
    if (getBrowser() === 'chrome' && browsers.includes('chrome')) {
      display = true;
    }
    if (getBrowser() === 'edge' && browsers.includes('edge')) {
      display = true;
    }
    if (getBrowser() === 'other' && browsers.includes('other')) {
      display = true;
    }
    if (display) this.setState({
      display: 'block'
    });else this.setState({
      display: 'none'
    });
  };
  _proto.componentDidMount = function componentDidMount() {
    this.setState({
      language: this.props.language
    });
    if (this.props.browsers) {
      this.showBrowsers(this.props.browsers);
    } else {
      this.setState({
        display: 'block'
      });
    }
  };
  _proto.render = function render() {
    var unsubscribe = null;
    if (this.state.unsubscribe) {
      unsubscribe = /*#__PURE__*/React.createElement("span", null, " | ", /*#__PURE__*/React.createElement("a", {
        href: "/unsubscribe/",
        target: "_blank"
      }, "Unsubscribe"));
    }
    var footertext = /*#__PURE__*/React.createElement("span", null, "Tightrope Interactive | ", /*#__PURE__*/React.createElement("a", {
      href: "/terms-of-service/",
      target: "_blank"
    }, "Terms"), " | ", /*#__PURE__*/React.createElement("a", {
      href: "/privacy-policy/",
      target: "_blank"
    }, "Privacy"), " | ", /*#__PURE__*/React.createElement("a", {
      href: "/uninstall/",
      target: "_blank"
    }, "Uninstall"), unsubscribe, " | ", /*#__PURE__*/React.createElement("a", {
      href: "/contact-us/",
      target: "_blank"
    }, "Contact"), " ", /*#__PURE__*/React.createElement("br", null), "All trademarks are property of their respective owners ", /*#__PURE__*/React.createElement("br", null), " ", /*#__PURE__*/React.createElement("a", {
      href: "/privacy-policy/#cali-consumer",
      target: "_blank"
    }, "Do Not Sell My Personal Information"));
    if (this.state.language == 'de') {
      footertext = /*#__PURE__*/React.createElement("span", null, "Tightrope Interactive | ", /*#__PURE__*/React.createElement("a", {
        href: "/terms-of-service/",
        target: "_blank"
      }, "Bedingungen"), " | ", /*#__PURE__*/React.createElement("a", {
        href: "/privacy-policy/",
        target: "_blank"
      }, "Datenschutz"), " | ", /*#__PURE__*/React.createElement("a", {
        href: "/uninstall/",
        target: "_blank"
      }, "Deinstallieren"), " | ", /*#__PURE__*/React.createElement("a", {
        href: "/unsubscribe/",
        target: "_blank"
      }, "Abbestellen"), " | ", /*#__PURE__*/React.createElement("a", {
        href: "/contact-us/",
        target: "_blank"
      }, "Kontakt"), " ", /*#__PURE__*/React.createElement("br", null), "Warenzeichen sind Eigentum ihrer jeweiligen Inhaber  ", /*#__PURE__*/React.createElement("br", null), " ", /*#__PURE__*/React.createElement("a", {
        href: "/privacy-policy/#cali-consumer",
        target: "_blank"
      }, "Verkaufen Sie meine pers\xF6nlichen Daten nicht"));
    }
    if (this.state.language == 'fr') {
      footertext = /*#__PURE__*/React.createElement("span", null, "Tightrope Interactive | ", /*#__PURE__*/React.createElement("a", {
        href: "/terms-of-service/",
        target: "_blank"
      }, "Conditions"), " | ", /*#__PURE__*/React.createElement("a", {
        href: "/privacy-policy/",
        target: "_blank"
      }, "Confidentialit\xE9 "), " | ", /*#__PURE__*/React.createElement("a", {
        href: "/uninstall/",
        target: "_blank"
      }, "D\xE9sinstaller "), " | ", /*#__PURE__*/React.createElement("a", {
        href: "/unsubscribe/",
        target: "_blank"
      }, "Se d\xE9sabonner "), " | ", /*#__PURE__*/React.createElement("a", {
        href: "/contact-us/",
        target: "_blank"
      }, "Contact"), " ", /*#__PURE__*/React.createElement("br", null), "Toutes les marques d\xE9pos\xE9es sont la propri\xE9t\xE9 de leurs propri\xE9taires respectifs   ", /*#__PURE__*/React.createElement("br", null), " ", /*#__PURE__*/React.createElement("a", {
        href: "/privacy-policy/#cali-consumer",
        target: "_blank"
      }, "Ne vendez pas mes informations personnelles"));
    }
    return /*#__PURE__*/React.createElement("div", {
      className: Styles.br,
      style: {
        display: this.state.display
      }
    }, footertext);
  };
  return FooterlinksSingle;
}(React.Component);
export default FooterlinksSingle;